import { mapState } from 'vuex'

const Services = {
    data() {
        return {
            formularioValido: false,
            cargando: false,
            tab: 1,
            servicioId: null,
            servicio: {
                nombre: null,
                cliente: '',
                campaña: null,
                subcampaña: null,
                segmento: null,
                sede: null,
                usuario_solicita: this.$store.state.id,
                usuario_encargado: '',
                fecha_elaboracion: new Date().toISOString().substr(0, 10),
                fecha_vigencia_inicio: '',
                fecha_vigencia_fin: ''
            },
            ventana: [],
            diasSemana: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
            diasSeleccionados: [],
            selectAllDays: false,
            horaInicioBase: '',
            horaFinBase: '',
            reglas: {
                descansos_semana: 1,
                descanso_interdia: 15,
                utilizacion: '',
                ausentismo: '',
                shrinkage: 10.0,
                auxiliares: []
            },
            menuFechas: [false, false],
            servicios: [],
            headers: [
                { text: 'Nombre', value: 'nombre' },
                //{ text: 'Canal', value: 'canal_nombre' },      // Usaremos slots para estos
                //{ text: 'Subcanal', value: 'subcanal_nombre' },
                { text: 'Cliente', value: 'nombre_cliente' },
                { text: 'Sede', value: 'nombre_centro' },
                { text: 'Segmento', value: 'nombre_segmento' },
                //{ text: 'Campaña', value: 'nombre_campaña' },
                { text: 'Subcampaña', value: 'nombre_subcampaña' },

                { text: 'Vigencia Inicio', value: 'fecha_vigencia_inicio' },
                { text: 'Vigencia Fin', value: 'fecha_vigencia_fin' },
                { text: 'Creado por', value: 'usuario_solicita' },
                { text: 'Acciones', value: 'acciones', sortable: false }],
            dialogEliminar: {
                visible: false,
                id: null,
                nombre: ''
            },
            //campañas: [],
            segmentos: [],
            clientes: [],
            usuarios: [],
            cargandoEdicion: false,
            intervalosHora: this.generarIntervalos(),
            mostrarSelectorImportar: false,
            servicioOrigenSeleccionado: null,
            ///////////////////////////////////////////
            nombresServiciosExistentes: [
                { id: 101, nombre: 'Servicio de Atención al Cliente' },
                { id: 102, nombre: 'Servicio Técnico Remoto' },
                { id: 103, nombre: 'Soporte L1' },
            ],
            servicioSeleccionadoId: null,
            canalesCargados: [],
            subcanalesCargados: [],
            canalSeleccionado: null,
            subcanalSeleccionado: null,
            paisSeleccionadoId: null,
            sedeSeleccionadoId: null,
            //campañaSeleccionadoId: null,
            subcampañaSeleccionadoId: null,
            segmentoSeleccionadoId: null,
            clienteSeleccionadoId: null,
            usuarioEncargadoSeleccionadoId: null,


            ////////////////////DATOS DE TURNOS////////////////////
            nuevoTurno: {
                servicio_id: null,
                nombre: '',
                intervalo_inicio: '',
                intervalo_fin: '',
                dias_aplicables: []
            },
            selectAllDiasAplicables: false,
            intervalosHora: this.generarIntervalos(),
            listaTurnos: [],
            turnosSeleccionados: [],
            dialogoConfirmarBorrado: false,
            mostrarToastExito: false,
            turnosHeaders: [
                { text: 'Bloque', value: 'nombre' },
                { text: 'Inicio', value: 'intervalo_inicio' },
                { text: 'Fin', value: 'intervalo_fin' },
                { text: 'Días', value: 'dias_aplicables' },
                { text: 'Acciones', value: 'acciones', align: 'end', sortable: false },
            ],
            indiceEdicionTurno: -1,

            //generacion automatica
            dialogoGeneracion: false,
            diasDisponiblesGeneracion: [],
            diasSeleccionadosGeneracion: [],

            // NUEVAS VARIABLES
            duracionTurnoMinutos: 480,
            duracionOpciones: [
                { text: '4 Horas (240 min)', value: 240 },
                { text: '5 Horas (300 min)', value: 300 },
                { text: '6 Horas (360 min)', value: 360 },
                { text: '7 Horas (420 min)', value: 420 },
                { text: '8 Horas (480 min)', value: 480 },
                { text: '9 Horas (540 min)', value: 540 },
                { text: '10 Horas (600 min)', value: 600 },
                { text: '11 Horas (660 min)', value: 660 },
                { text: '12 Horas (720 min)', value: 720 },
            ],

            tipoGeneracion: 'escalonado',
            tiposGeneracion: [
                { text: 'Escalonado (Turno A termina donde empieza B)', value: 'escalonado' },
                { text: 'Empalmado (Turno B inicia antes de que A termine)', value: 'empalmado' },
            ],

            intervaloEntreTurnosMinutos: 60,
            intervaloOpciones: [
                { text: '15 minutos', value: 15 },
                { text: '30 minutos', value: 30 },
                { text: '60 minutos (1 hora)', value: 60 }
            ],
            horasTimeline: [],
            horaInicioTimeline: null,
            horaFinTimeline: null,

            coloresTimeline: ['#1976D2', '#4CAF50', '#FF9800', '#F44336', '#9C27B0'],
            alturaCarril: 35,
            dialogEliminar: { id: null, nombre: '', visible: false },
            dialogEliminarMasivo: { nombre: '', visible: false },
            cobertura: false,
            horaInicioCiclo: '00:00',
            //importado
            mostrarSelectorImportarTurnos: false,
            turnosCopiadosTemporal: [],
            servicioOrigenSeleccionadoTurno: null,
            servicioDestinoSeleccionado: null,
            turnoEditando: null,
            indiceEditando: -1,
            isSaving: false,

            dialogVerTurnos: false,
            servicioSeleccionadoTurno: {},

        };
    },
    async mounted() {
        await this.cargarServicios();
        if (this.canalesGlobales.length === 0) {
            await this.$store.dispatch('listCanalesSubcanales');
        }
        this.cargarCatalogo();
    },
    computed: {
        intervalosTurnoDisponibles() {
            if (!this.ventana || this.ventana.length === 0) {
                return [];
            }

            // Para la captura manual usamos la ventana operativa
            // del primer día configurado.
            const ventana = this.ventana[0];

            if (!ventana || !ventana.inicio || !ventana.fin) {
                return [];
            }

            return this.generarHorasValidas(
                ventana.inicio.substring(0, 5),
                ventana.fin.substring(0, 5)
            );
        },
        nombreUsuarioSolicita() {
            return this.$store.state.username;
        },
        paises() {
            //console.log(this.$store.state.paises)
            return this.$store.state.paises;
        },
        centros() {
            return this.$store.state.centers
        },
        centrosFiltrados() {
            if (!this.$store.state.centers || !this.paisSeleccionadoId) return [];

            return this.$store.state.centers.filter(c => Number(c.inPaisId) === this.paisSeleccionadoId);
        },
        pais() {
            return this.$store.state.pais;
        },
        segmentosFiltrados() {
            return this.$store.state.segmentos
        },
        /*campanasFiltradas1() {
            if (!this.$store.state.campañas) return [];

            return this.$store.state.campañas.filter(c => c.in_segmentoid === this.segmentoSeleccionadoId);
        },*/
        subcampanasFiltradas() {
            //console.log(this.$store.state.subcampañas)
            //console.log(this.campañaSeleccionadoId)
            if (!this.$store.state.subcampañas) return [];

            return this.$store.state.subcampañas.filter(c => {
                const coincideCentro = c.in_CentroId === this.sedeSeleccionadoId;

                const coincideSegmento = this.segmentoSeleccionadoId
                    ? c.in_SegmentoId === this.segmentoSeleccionadoId
                    : true;

                return coincideCentro && coincideSegmento;
            });
        },

        /*campanasFiltradas() {
            const campanas = this.$store.state.campañas;
            if (!campanas) return [];

            return campanas.filter(c => {
                // Si hay sede seleccionada, valida contra id_sede; si no hay sede, ignora esta regla
                const coincideSede = !this.sedeSeleccionadoId
                    ? true
                    : Number(c.id_sede || c.in_centroid || c.in_CentroId) === Number(this.sedeSeleccionadoId);

                // Valida contra el segmento seleccionado
                const coincideSegmento = !this.segmentoSeleccionadoId
                    ? true
                    : Number(c.in_segmentoid || c.id_segmento) === Number(this.segmentoSeleccionadoId);

                return coincideSede && coincideSegmento;
            });
        },*/

        // 4. Filtra Subcampaña basada en la Campaña elegida
        /*subcampanasFiltradas1() {
            //console.log(this.$store.state.subcampañas);

            const subcampanas = this.$store.state.subcampañas;
            if (!subcampanas) return [];

            // Si el usuario eligió una Campaña WFM, las subcampañas se reducen únicamente a esa campaña
            if (this.campañaSeleccionadoId) {
                //console.log(this.campañaSeleccionadoId);
                return subcampanas.filter(sub =>
                    Number(sub.in_campanaidwfm) === Number(this.campañaSeleccionadoId)
                );
            }

            // Si AÚN NO selecciona campaña pero tiene Sede o Segmento,
            // muestra las subcampañas que coincidan con lo que lleve seleccionado
            subcampanas.filter(sub => {
                const coincideSede = !this.sedeSeleccionadoId
                    ? true
                    : Number(sub.in_CentroId) === Number(this.sedeSeleccionadoId);

                const coincideSegmento = !this.segmentoSeleccionadoId
                    ? true
                    : Number(sub.in_SegmentoId) === Number(this.segmentoSeleccionadoId);

                return coincideSede && coincideSegmento;
            });
            //console.log(subcampanas);
            return subcampanas;
        },*/

        datosTaf() {
            return this.$store.state.datosTaf
        },
        usuariosFiltrados() {
            return this.$store.state.usuarios.filter(
                c => c.in_CampanaId === this.subcampañaSeleccionadoId
            );
        },
        clientesFiltrados() {
            return this.$store.state.clientes
        },
        serviciosVisibles() {
            //console.log(this.servicios)
            //console.log(this.$store.state.campañas)
            return this.servicios.map(servicio => {
                return {
                    ...servicio,
                    nombre_centro: this.centros.find(c => c.Id === Number(servicio.sede))?.vc_Descripcion || servicio.sede || '—',
                    //nombre_campaña: this.$store.state.campañas.find(c => c.id === Number(servicio.campana))?.vc_descripcion || servicio.campana || '—',
                    nombre_subcampaña: this.$store.state.subcampañas.find(c => c.Id === Number(servicio.subcampana))?.vc_Descripcion || servicio.subcampana || '—',
                    nombre_segmento: this.segmentosFiltrados.find(s => s.Id === Number(servicio.segmento))?.vc_Descripcion || servicio.segmento || '—',
                    nombre_cliente: this.clientesFiltrados.find(c => c.id === Number(servicio.cliente))?.vc_nombre || servicio.cliente || '—',
                    nombre_encargado: this.usuariosFiltrados.find(u => u.id === Number(servicio.usuario_encargado))?.nombre_completo || servicio.usuario_encargado || '—'
                };
            });
        },
        formularioPaso1Valido() {
            return this.servicio &&
                this.servicio.nombre &&
                this.servicio.usuario_solicita &&
                this.servicio.fecha_elaboracion &&
                this.servicio.fecha_vigencia_inicio &&
                this.servicio.fecha_vigencia_fin &&
                !this.servicioDuplicadoPropio
            // Puedes agregar más campos si son obligatorios en el primer paso (como cliente, sede, etc., que tienes comentados)
        },


        serviciosCoincidentes() {
            const nombre = this.servicio.nombre;
            const inicio = this.servicio.fecha_vigencia_inicio;
            const fin = this.servicio.fecha_vigencia_fin;

            // Esperar a que se completen los campos
            if (!nombre || !inicio || !fin) {
                return [];
            }

            // Normalizar el nombre del servicio
            const normalizarNombre = valor => {
                if (valor && typeof valor === 'object') {
                    valor = valor.vc_descripcion || '';
                }

                return String(valor || '')
                    .trim()
                    .toLowerCase();
            };

            return this.servicios.filter(servicio => {

                // No comparar el registro consigo mismo al editar
                if (
                    this.servicioId &&
                    String(servicio.id) === String(this.servicioId)
                ) {
                    return false;
                }

                return (
                    normalizarNombre(servicio.nombre) ===
                    normalizarNombre(nombre) &&

                    servicio.fecha_vigencia_inicio === inicio &&

                    servicio.fecha_vigencia_fin === fin
                );
            });
        },

        servicioDuplicadoPropio() {
            return this.serviciosCoincidentes.some(servicio =>
                String(servicio.usuario_solicita) ===
                String(this.$store.state.id)
            );
        },
        ventanaPaso2Valida() {
            return this.ventana.length > 0 && this.ventana.every(d => d.inicio && d.fin);
        },
        auxiliaresPaso3Valido() {
            const descansos = this.reglas.descansos_semana;

            return Number.isInteger(Number(descansos)) &&
                Number(descansos) >= 1 &&
                Number(descansos) <= 6 &&
                this.reglas.auxiliares.every(aux => {

                    const jornadaMin = this.tiempoAHorasMinutos(aux.jornada_min);
                    const jornadaMax = this.tiempoAHorasMinutos(aux.jornada_max);

                    return (
                        !!aux.tipo &&

                        // Duración
                        this.validarDuracion(aux.duracion) === true &&

                        // Jornada mínima
                        jornadaMin !== null &&
                        jornadaMin > 0 &&

                        // Jornada máxima
                        jornadaMax !== null &&
                        jornadaMax > jornadaMin &&

                        // Límites del auxiliar
                        this.validarTiempo(aux.min_desde_inicio) === true &&
                        this.validarTiempo(aux.max_antes_fin) === true
                    );
                });
        },
        reglasPaso4Validas() {
            return this.reglas.utilizacion !== '' &&
                this.reglas.ausentismo !== '';
        },
        reglasPaso5Validas() {
            return this.listaTurnos.length != 0
        },
        subcanalesFiltrados() {
            if (!this.canalSeleccionado) {
                return []; // No mostrar nada si no hay canal seleccionado
            }
            return this.subcanalesCargados.filter(subcanal =>
                subcanal.in_canal_id === this.canalSeleccionado
            );
        },
        ...mapState(['canalesGlobales', 'subcanalesGlobales']),

        /////////////TURNOS Y JORNADAS /*//////////
        nombreTurnoGenerado: {
            get() {
                if (this.nuevoTurno.nombre) {
                    return this.nuevoTurno.nombre;
                }

                const servicioSeleccionado = this.servicio;
                const nombreServicio = servicioSeleccionado ? servicioSeleccionado.nombre : 'Servicio';

                let diasTexto = '';
                if (this.nuevoTurno.dias_aplicables.length === this.diasSemana.length) {
                    diasTexto = 'Todos los días';
                } else if (this.nuevoTurno.dias_aplicables.length > 0) {
                    diasTexto = this.nuevoTurno.dias_aplicables.join(', ');
                } else {
                    diasTexto = 'Días sin definir';
                }

                const horaInicio = this.nuevoTurno.intervalo_inicio || 'HH:MM';
                const horaFin = this.nuevoTurno.intervalo_fin || 'HH:MM';

                return `${nombreServicio} - ${diasTexto} (${horaInicio} a ${horaFin})`;
            },
            set(value) {
                this.nuevoTurno.nombre = value;
            }
        },
        esTurnoValido() {
            return this.nuevoTurno.dias_aplicables.length > 0 &&
                this.nuevoTurno.intervalo_inicio &&
                this.nuevoTurno.intervalo_fin;
        },
        selectAllDiasGeneracion: {
            get() {
                return this.diasSeleccionadosGeneracion.length === this.diasDisponiblesParaTurnos.length && this.diasDisponiblesParaTurnos.length > 0;
            },
            set(value) {
                if (value) {
                    this.diasSeleccionadosGeneracion = [...this.diasDisponiblesParaTurnos];
                } else {
                    this.diasSeleccionadosGeneracion = [];
                }
            }
        },
        diasDisponiblesParaTurnos() {
            if (!this.ventana || this.ventana.length === 0) return [];

            // Obtenemos los días que están en la ventana operativa
            // Usamos Set para evitar días duplicados si hay varias ventanas el mismo día
            const diasEnVentana = [...new Set(this.ventana.map(v => v.dia))];

            return diasEnVentana;
        },
        hayTurnosInvalidos() {
            return this.turnosCopiadosTemporal.some(turno => !turno.esValido);
        },
        turnosFiltrados() {
            if (!this.servicioSeleccionadoTurno.id) return [];
            return this.turnosCatalogo.filter(t => t.servicio_id === this.servicioSeleccionadoTurno.id);
        },
        esServicio24HorasActual() {
            if (!this.ventana || this.ventana.length === 0) return false;

            // 1. Intentamos filtrar por los días de la generación automática
            let ventanaFiltrada = this.ventana.filter(item =>
                this.diasSeleccionadosGeneracion && this.diasSeleccionadosGeneracion.includes(item.dia)
            );

            // 2. Si está vacío (porque estamos creando un turno manual), usamos la ventana completa
            if (ventanaFiltrada.length === 0) {
                ventanaFiltrada = this.ventana;
            }

            // 3. Comparamos inicio y fin de forma segura
            const primerDia = ventanaFiltrada[0];
            if (!primerDia || !primerDia.inicio || !primerDia.fin) return false;

            return primerDia.inicio.substring(0, 5) === primerDia.fin.substring(0, 5);
        }
    },
    watch: {
        paisSeleccionadoId() {
            if (this.servicio) {
                this.servicio.sede = null;
            }
        },
        selectAllDays(newVal) {
            if (this.isUncheckAction && newVal === false) {
                this.isUncheckAction = false;
                return;
            }
            if (newVal) {
                this.diasSeleccionados = [...this.diasSemana];
            } else {
                this.diasSeleccionados = [];
            }
        },
        diasSeleccionados(newVal, oldVal) {
            const isFullSelection = (newVal.length === this.diasSemana.length);
            if (this.selectAllDays && !isFullSelection) {
                this.isUncheckAction = true;
            }
            this.selectAllDays = isFullSelection;

            if (!this.servicioId) return;

            const daysToRemove = oldVal.filter(day => !newVal.includes(day));
            if (daysToRemove.length > 0) {
                this.ventana = this.ventana.filter(v => !daysToRemove.includes(v.dia));
            }

            const existingDays = this.ventana.map(v => v.dia);
            const daysToAdd = newVal.filter(day => !existingDays.includes(day));

            if (daysToAdd.length > 0) {
                const newV = daysToAdd.map(dia => ({
                    dia,
                    inicio: this.horaInicioBase,
                    fin: this.horaFinBase
                }));
                this.ventana = [...this.ventana, ...newV];
            }
        },
        horaInicioBase(newVal) {
            if (this.servicioId && newVal) {
                this.ventana = this.ventana.map(v => ({
                    ...v, inicio: newVal
                }));
            }
        },
        horaFinBase(newVal) {
            if (this.servicioId && newVal) {
                this.ventana = this.ventana.map(v => ({
                    ...v, fin: newVal
                }));
            }
        },

        /////// TURNOS Y JORNADAS /////
        selectAllDiasAplicables(newVal) {
            if (this.isManualChange && newVal === false) {
                this.isManualChange = false;
                return;
            }
            if (newVal) {
                this.nuevoTurno.dias_aplicables = [...this.diasSemana];
            } else {
                this.nuevoTurno.dias_aplicables = [];
            }
        },

        'nuevoTurno.dias_aplicables': {
            handler(newVal) {
                const isFullSelection = (newVal.length === this.diasSemana.length);
                if (this.selectAllDiasAplicables && !isFullSelection) {
                    this.isManualChange = true;
                }
                this.selectAllDiasAplicables = isFullSelection;
            },
            deep: true
        }
    },

    methods: {
        obtenerNombreUsuario(usuarioId) {
            if (!usuarioId) return 'Sin asignar';

            const usuario = this.$store.state.usuariosall.find(
                u => Number(u.id) === Number(usuarioId)
            );

            return usuario
                ? usuario.nombre_completo
                : 'Usuario no encontrado';
        },

        esPropietarioServicio(servicio) {
            if (!servicio || servicio.usuario_solicita == null) {
                return false;
            }

            const usuarioActualId = this.$store.state.id;

            if (usuarioActualId == null) {
                return false;
            }

            return String(servicio.usuario_solicita) === String(usuarioActualId);
        },

        ordenarDias(dias) {
            if (!dias || dias.length === 0) return [];

            const ordenMap = this.diasSemana.reduce((acc, dia, index) => {
                acc[dia] = index;
                return acc;
            }, {});

            return dias.slice().sort((a, b) => {
                const indexA = ordenMap[a] !== undefined ? ordenMap[a] : 99;
                const indexB = ordenMap[b] !== undefined ? ordenMap[b] : 99;

                return indexA - indexB;
            });
        },
        obtenerNombreCanal(id) {
            if (!id || id == 0) return 'N/A';
            const canal = this.$store.state.canalesGlobales.find(c => c.id == id);
            return canal ? canal.vc_descripcion : 'No encontrado';
        },

        obtenerNombreSubcanal(id) {
            if (!id || id == 0) return 'N/A';
            const subcanal = this.$store.state.subcanalesGlobales.find(s => s.id == id);
            return subcanal ? subcanal.vc_descripcion : 'No encontrado';
        },
        async actualizarListaTaf() {
            // Esto dispara la acción que ya tienes en Vuex
            await this.$store.dispatch('listDatosTaf');
        },
        async actualizarCanalesSubcanales() {
            // Esto dispara la acción que ya tienes en Vuex
            await this.$store.dispatch('listCanalesSubcanales');
        },

        manejarSeleccionOEscritura(valorDelCampo) {
            if (typeof valorDelCampo === 'object' && valorDelCampo !== null) {
                const idSeleccionado = valorDelCampo.id;
                this.servicioSeleccionadoId = idSeleccionado;
                this.servicio.nombre = valorDelCampo.vc_descripcion; // Forzar el nombre a ser el texto del objeto

                //console.log(`Servicio existente seleccionado. ID a guardar: ${this.servicioSeleccionadoId}`);
                //this.cargarCanalesPorTarificador(idSeleccionado);
                //this.cargarSubcanalesPorTarificador(idSeleccionado); // ¡NUEVO!
                // Filtramos directamente del Store
                this.canalesCargados = this.$store.state.canalesGlobales.filter(
                    c => c.id_tarificador === idSeleccionado
                );
                this.subcanalesCargados = this.$store.state.subcanalesGlobales.filter(
                    s => s.id_tarificador === idSeleccionado
                );
                this.canalSeleccionado = null;
                this.subcanalSeleccionado = null;
            }

            else if (typeof valorDelCampo === 'string' && valorDelCampo) {

                this.servicioSeleccionadoId = null; // No hay ID, es un servicio nuevo
                this.servicio.nombre = valorDelCampo; // El nombre ya está guardado

                //console.log(`Nuevo servicio tecleado. Nombre: ${this.servicio.nombre}`);
                this.canalesCargados = [];
                this.subcanalesCargados = [];
                this.canalSeleccionado = null;
                this.subcanalSeleccionado = null;

            } else {
                this.servicioSeleccionadoId = null;
                this.servicio.nombre = null;
                this.canalesCargados = [];
                this.subcanalesCargados = [];
                this.canalSeleccionado = null;
                this.subcanalSeleccionado = null;
            }
        },
        sedeSeleccionEscritura(valor) {
            this.servicio.subcampaña = null;
            if (typeof valor === 'object' && valor !== null) {
                const idSeleccionado = valor.Id;
                this.sedeSeleccionadoId = idSeleccionado;
                this.servicio.sede = valor.vc_Descripcion;
            } else if (typeof valor === 'string' && valor.trim() !== "") {
                this.sedeSeleccionadoId = null; // No hay ID, es un servicio nuevo
                this.servicio.sede = valor;
            } else {
                this.sedeSeleccionadoId = null;
                this.servicio.sede = null;
            }
        },
        /*campanaSeleccionEscritura(valor) {
            this.servicio.campaña = null;
            if (typeof valor === 'object' && valor !== null) {
                this.campañaSeleccionadoId = valor.id
                this.servicio.campaña = valor.vc_descripcion;
                //this.servicio.nombre = valor.vc_descripcion;
            } else if (typeof valor === 'string' && valor.trim() !== "") {
                this.campañaSeleccionadoId = null;
                this.servicio.campaña = valor;
                //this.servicio.nombre = valor;
            } else {
                this.campañaSeleccionadoId = null;
                this.servicio.campaña = null;
            }


        },*/
        subcampanaSeleccionEscritura(valor) {
            this.servicio.subcampaña = null;
            if (typeof valor === 'object' && valor !== null) {
                this.subcampañaSeleccionadoId = valor.Id
                this.servicio.subcampaña = valor.vc_Descripcion;
                //console.log(this.servicioId);
                if (!this.servicioId) {
                    this.servicio.nombre = valor.vc_descripcion || valor.vc_Descripcion;
                }
                //this.servicio.nombre = valor.vc_Descripcion;
            } else if (typeof valor === 'string' && valor.trim() !== "") {
                this.subcampañaSeleccionadoId = null;
                this.servicio.subcampaña = valor;
                //this.servicio.nombre = valor;
                if (!this.servicioId) {
                    this.servicio.nombre = valor;
                }
            } else {
                this.subcampañaSeleccionadoId = null;
                this.servicio.subcampaña = null;
            }


        },
        segmentoSeleccionEscritura(valor) {
            if (typeof valor === 'object' && valor !== null) {
                this.segmentoSeleccionadoId = valor.Id
                this.servicio.segmento = valor.vc_Descripcion;
            } else if (typeof valor === 'string' && valor.trim() !== "") {
                this.segmentoSeleccionadoId = null;
                this.servicio.segmento = valor;
            } else {
                this.segmentoSeleccionadoId = null;
                this.servicio.segmento = null;
            }
        },
        clienteSeleccionEscritura(valor) {
            if (typeof valor === 'object' && valor !== null) {
                this.clienteSeleccionadoId = valor.id
                this.servicio.cliente = valor.vc_nombre;
            } else if (typeof valor === 'string' && valor.trim() !== "") {
                this.clienteSeleccionadoId = null;
                this.servicio.cliente = valor;
            } else {
                this.clienteSeleccionadoId = null;
                this.servicio.cliente = null;
            }
        },
        usuarioEncargadoSeleccionEscritura(valor) {
            if (typeof valor === 'object' && valor !== null) {
                this.usuarioEncargadoSeleccionadoId = valor.id
                this.servicio.usuario_encargado = valor.nombre_completo;
            } else if (typeof valor === 'string' && valor.trim() !== "") {
                this.usuarioEncargadoSeleccionadoId = null;
                this.servicio.usuario_encargado = valor;
            } else {
                this.usuarioEncargadoSeleccionadoId = null;
                this.servicio.usuario_encargado = null;
            }
        },
        async cargarCanalesPorTarificador(idTarificador) {
            if (!idTarificador) return;

            try {
                const res = await this.$axios.get(`canales-tarificador/${idTarificador}`);

                this.canalesCargados = res.data.canales;

            } catch (error) {
                console.error("Error al cargar canales:", error);
                this.$toast.error("Error al obtener los canales asociados.");
                this.canalesCargados = [];
            }
        },
        async cargarSubcanalesPorTarificador(idTarificador) {
            if (!idTarificador) return;

            try {
                const res = await this.$axios.get(`subcanales-tarificador/${idTarificador}`);
                this.subcanalesCargados = res.data.subcanales;

                // Opcional: mostrar un mensaje de éxito/debug
                //console.log(`Subcanales cargados:`, this.subcanalesCargados);

            } catch (error) {
                console.error("Error al cargar subcanales:", error);
                this.$toast.error("Error al obtener los subcanales asociados.");
                this.subcanalesCargados = [];
            }
        },

        ///////////////////////////////
        validarTiempo(val) {
            if (!val) return 'Este campo es obligatorio';

            if (!/^\d{2}:\d{2}$/.test(val)) {
                return 'Formato inválido. Usa hh:mm';
            }

            const [horas, minutos] = val.split(':').map(Number);

            if (minutos >= 60) {
                return 'Los minutos deben ser menores a 60.';
            }
            const total = (horas * 60) + minutos;

            if (total > 240) return 'Máximo permitido: 04:00';

            return true;
        },
        validarDuracion(val) {
            if (!val) return 'Este campo es obligatorio';

            if (!/^\d{2}:\d{2}$/.test(val)) {
                return 'Formato inválido. Usa hh:mm';
            }

            const [horas, minutos] = val.split(':').map(Number);

            if (minutos >= 60) {
                return 'Los minutos deben ser menores a 60';
            }

            return true;
        },

        tiempoAHorasMinutos(valor) {
            if (!valor || typeof valor !== 'string') return null;

            if (!/^\d{2}:\d{2}$/.test(valor)) {
                return null;
            }

            const [horas, minutos] = valor.split(':').map(Number);

            if (minutos >= 60) {
                return null;
            }

            return (horas * 60) + minutos;
        },

        validarJornadaMin(aux) {
            const min = this.tiempoAHorasMinutos(aux.jornada_min);

            if (min === null) {
                return 'Formato inválido. Usa hh:mm';
            }

            if (min <= 0) {
                return 'Debe ser mayor a 00:00';
            }

            if (aux.jornada_max) {
                const max = this.tiempoAHorasMinutos(aux.jornada_max);

                if (max !== null && min >= max) {
                    return 'Debe ser menor que la jornada máxima';
                }
            }

            return true;
        },

        validarJornadaMax(aux) {
            const max = this.tiempoAHorasMinutos(aux.jornada_max);

            if (max === null) {
                return 'Formato inválido. Usa hh:mm';
            }

            if (max <= 0) {
                return 'Debe ser mayor a 00:00';
            }

            if (aux.jornada_min) {
                const min = this.tiempoAHorasMinutos(aux.jornada_min);

                if (min !== null && max <= min) {
                    return 'Debe ser mayor que la jornada mínima';
                }
            }

            return true;
        },
        convertirHMMADecimal(valorHMM) {
            if (!valorHMM || typeof valorHMM !== 'string') return "0.00";

            if (!/^\d+:\d{2}$/.test(valorHMM)) {
                return "0.00";
            }

            const [h, m] = valorHMM.split(':');
            const horas = parseInt(h);
            const minutos = parseInt(m);

            const fraccionDecimal = minutos / 60;

            return (horas + fraccionDecimal).toFixed(2).toString();
        },
        convertirHHMMADecimal(valor) {
            if (!valor || typeof valor !== 'string') return 0;

            if (!/^\d{2}:\d{2}$/.test(valor)) {
                return 0;
            }

            const [horas, minutos] = valor.split(':').map(Number);

            return horas + (minutos / 60);
        },
        convertirDecimalAHHMM(valor) {
            if (valor === null || valor === undefined || valor === '') {
                return '';
            }

            const valorDecimal = parseFloat(valor);

            if (isNaN(valorDecimal)) {
                return '';
            }

            const totalMinutos = Math.round(valorDecimal * 60);

            const horas = Math.floor(totalMinutos / 60);
            const minutos = totalMinutos % 60;

            return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`;
        },

        convertirHHMMSSAHHMM(valor) {
            if (!valor) return '';

            const partes = String(valor).split(':');

            if (partes.length !== 3) {
                // Ya podría venir como hh:mm
                return /^\d{2}:\d{2}$/.test(String(valor))
                    ? String(valor)
                    : '';
            }

            return `${String(partes[0]).padStart(2, '0')}:${String(partes[1]).padStart(2, '0')}`;
        },
        validarHoraFin(horaInicio, horaFin) {
            return !!horaInicio && !!horaFin || 'Debes ingresar ambas horas';
        },
        crearVentana() {
            this.ventana = this.diasSeleccionados.map(dia => ({
                dia,
                inicio: this.horaInicioBase,
                fin: this.horaFinBase
            }));
        },
        calcularReductor(utz, abs) {
            if (!utz || !abs) return 0;
            const r = ((1 / (utz / 100)) / (1 - (abs / 100))) - 1;
            return Math.round(r * 10000) / 100;
        },
        async cargarServicios() {
            this.cargando = true;
            try {
                const usuarioId = this.$store.state.id;
                const res = await this.$axios.get('list-services-all');
                this.servicios = res.data;
                //console.log(this.servicios);
            } catch (err) {
                console.error('Error al cargar servicios:', err);
                this.$toast.error('No se pudieron cargar los servicios');
            } finally {
                this.cargando = false;
            }

        },
        async guardarServicio() {

            const esFormularioValido = this.$refs.formServicio.validate();
            const servicioValido = this.formularioPaso1Valido;

            const ventanaValida = this.ventanaPaso2Valida;

            const auxiliaresValidos = this.auxiliaresPaso3Valido;

            if (!auxiliaresValidos) {
                this.$toast.error('Completa correctamente los campos de auxiliares (tipo, duración, jornada, min inicio, min fin).');
                return;
            }

            const reglasValidas = this.reglasPaso4Validas;

            if (
                !esFormularioValido ||
                !servicioValido ||
                !ventanaValida ||
                !reglasValidas
            ) {
                this.$toast.error("Completa todos los campos correctamente en todas las pestañas.");
                return;
            }
            /*const auxiliaresConvertidos = this.reglas.auxiliares.map(aux => ({
                ...aux,
                min_desde_inicio_min: this.convertirHorasDecimalAMinutos(aux.min_desde_inicio),
                max_antes_fin_min: this.convertirHorasDecimalAMinutos(aux.max_antes_fin)
            }));*/
            const auxiliaresConvertidos = this.reglas.auxiliares.map(aux => {

                const decimalDesdeInicio =
                    this.convertirHHMMADecimal(aux.min_desde_inicio);

                const decimalAntesFin =
                    this.convertirHHMMADecimal(aux.max_antes_fin);

                const jornadaMin =
                    this.convertirHHMMADecimal(aux.jornada_min);

                const jornadaMax =
                    this.convertirHHMMADecimal(aux.jornada_max);

                return {
                    ...aux,

                    // Backend conserva sus valores decimales
                    jornada_min: jornadaMin,
                    jornada_max: jornadaMax,

                    min_desde_inicio: decimalDesdeInicio,
                    max_antes_fin: decimalAntesFin,

                    // Valores en minutos utilizados por otros módulos
                    min_desde_inicio_min: Math.round(decimalDesdeInicio * 60),
                    max_antes_fin_min: Math.round(decimalAntesFin * 60)
                };
            });

            this.cargandoEdicion = true;
            try {
                const payload = {
                    ...this.servicio,
                    //nuevo dato
                    servicio_id_seleccionado: this.servicioSeleccionadoId,
                    canal_id: this.canalSeleccionado,
                    subcanal_id: this.subcanalSeleccionado,
                    sede_id_seleccionado: this.sedeSeleccionadoId,
                    //campaña_id_seleccionado: this.campañaSeleccionadoId,
                    subcampaña_id_seleccionado: this.subcampañaSeleccionadoId,
                    segmento_id_seleccionado: this.segmentoSeleccionadoId,
                    cliente_id_seleccionado: this.clienteSeleccionadoId,
                    usuario_encargado_id_seleccionado: this.usuarioEncargadoSeleccionadoId,
                    pais_id: this.paisSeleccionadoId ? Number(this.paisSeleccionadoId) : null,

                    ventanas: this.ventana,
                    descansos_semana: this.reglas.descansos_semana,
                    descanso_interdia: this.reglas.descanso_interdia,
                    utilizacion: this.reglas.utilizacion,
                    ausentismo: this.reglas.ausentismo,
                    shrinkage: this.calcularReductor(this.reglas.utilizacion, this.reglas.ausentismo),
                    auxiliares: auxiliaresConvertidos,
                    turnos: this.listaTurnos
                };

                //console.log(payload);
                let res;
                if (this.servicioId) {
                    res = await this.$axios.put(`servicio/${this.servicioId}`, payload);
                } else {
                    res = await this.$axios.post('guardar-servicio', payload);
                }

                if (res.data.status === 'ok') {
                    this.$toast.success(this.servicioId ? 'Servicio actualizado correctamente' : 'Servicio registrado correctamente');
                    this.limpiarFormulario();
                    await this.cargarServicios();
                    this.cargarCatalogo();
                } else {
                    this.$toast.error(res.data.message);
                    //this.$toast.error('Error al guardar');
                }
            } catch (err) {
                console.error(err);
                this.$toast.error('Error de conexión');
            }
            finally {
                this.cargandoEdicion = false;
            }
        },
        convertirHorasDecimalAMinutos(valor) {
            if (!valor || typeof valor !== 'string') return 0;
            const partes = valor.split('.');
            const horas = parseInt(partes[0]) || 0;
            const minutos = parseInt(partes[1]) || 0;
            return horas * 60 + Math.round((minutos / 100) * 60);
        },
        eliminarAuxiliar(index) {
            this.reglas.auxiliares.splice(index, 1);
        },
        async editarServicio(item) {
            this.cargandoEdicion = true;

            this.servicioId = item.id;
            try {
                const res = await this.$axios.get(`servicio/${item.id}`);
                const data = res.data;
                //console.log(res.data);


                this.servicio = {
                    //nombre: data.servicio.nombre,
                    cliente: Number(data.servicio.cliente),
                    //sede: Number(data.servicio.sede),
                    //campaña: Number(data.servicio.campaña),
                    segmento: Number(data.servicio.segmento),
                    usuario_solicita: data.servicio.usuario_solicita,
                    usuario_encargado: Number(data.servicio.usuario_encargado),
                    fecha_elaboracion: data.servicio.fecha_elaboracion,
                    fecha_vigencia_inicio: data.servicio.fecha_vigencia_inicio,
                    fecha_vigencia_fin: data.servicio.fecha_vigencia_fin
                };
                const idTarificador = data.servicio.id_tarificador;
                this.servicioSeleccionadoId = data.servicio.id_tarificador;

                this.paisSeleccionadoId = data.servicio.pais_id ? Number(data.servicio.pais_id) : null;

                this.sedeSeleccionadoId = data.servicio.sede; // Asegúrate que el backend mande sede_id
                //this.campañaSeleccionadoId = data.servicio.campana;
                this.subcampañaSeleccionadoId = data.servicio.subcampana;
                //console.log(this.campañaSeleccionadoId);
                //console.log(this.subcampañaSeleccionadoId);
                this.segmentoSeleccionadoId = data.servicio.segmento;
                this.clienteSeleccionadoId = data.servicio.cliente;
                this.usuarioEncargadoSeleccionadoId = data.servicio.usuario_encargado;

                if (idTarificador) {
                    // 1. Encontrar el objeto completo en la lista de items (datosTaf)
                    const tarificadorSeleccionado = this.datosTaf.find(
                        t => t.id === idTarificador
                    );

                    if (tarificadorSeleccionado) {
                        // 2. Asignar el OBJETO COMPLETO al v-model
                        this.servicio.nombre = tarificadorSeleccionado;

                        // 3. Disparar manualmente la lógica de carga, como si el usuario lo hubiera seleccionado
                        this.manejarSeleccionOEscritura(tarificadorSeleccionado);
                    } else {
                        // Si no encuentra el tarificador, simplemente usa el nombre
                        this.servicio.nombre = data.servicio.nombre;
                        this.servicioSeleccionadoId = null; // No lo encontramos, lo tratamos como manual
                        this.manejarSeleccionOEscritura(data.servicio.nombre);
                    }
                } else {
                    // Servicio registrado manualmente, solo asignamos el nombre simple
                    this.servicio.nombre = data.servicio.nombre;
                    this.manejarSeleccionOEscritura(data.servicio.nombre);
                }
                //MANEJO SEDE
                this.$nextTick(() => {
                    if (this.sedeSeleccionadoId) {
                        const sedeSeleccionado = this.centros.find(
                            t => t.Id === Number(this.sedeSeleccionadoId)
                        );
                        //console.log(sedeSeleccionado);

                        if (sedeSeleccionado) {
                            this.servicio.sede = sedeSeleccionado;
                        } else {
                            this.servicio.sede = data.servicio.sede;
                            this.sedeSeleccionadoId = null;
                        }
                    } else {
                        this.servicio.sede = data.servicio.sede;
                    }
                    this.sedeSeleccionEscritura(this.servicio.sede);
                })

                //MANEJO CAMPAÑA
                /*this.$nextTick(() => {
                    if (this.campañaSeleccionadoId) {
                        //console.log(this.campañasFiltradas);
                        const campanaSeleccionado = this.campanasFiltradas.find(
                            t => t.id == Number(this.campañaSeleccionadoId)
                        );
                        console.log(campanaSeleccionado);

                        if (campanaSeleccionado) {
                            this.servicio.campaña = campanaSeleccionado;
                        } else {
                            this.servicio.campaña = data.servicio.campana;
                            this.campañaSeleccionadoId = null;
                        }
                    } else {
                        this.servicio.campaña = data.servicio.campana;
                    }
                    this.campanaSeleccionEscritura(this.servicio.campaña);
                })*/

                //MANEJO SUBCAMPANA
                this.$nextTick(() => {
                    if (this.subcampañaSeleccionadoId) {
                        const subcampañaSeleccionado = this.subcampanasFiltradas.find(
                            t => t.Id == Number(this.subcampañaSeleccionadoId)
                        );
                        //console.log(subcampañaSeleccionado);

                        if (subcampañaSeleccionado) {
                            this.servicio.subcampaña = subcampañaSeleccionado;
                        } else {
                            this.servicio.subcampaña = data.servicio.subcampana;
                            this.subcampañaSeleccionadoId = null;
                        }
                    } else {
                        this.servicio.subcampaña = data.servicio.subcampana;
                    }
                    this.subcampanaSeleccionEscritura(this.servicio.subcampaña);
                })

                //MANEJO SEGMENTO
                if (this.segmentoSeleccionadoId) {
                    const segmentoSeleccionado = this.segmentosFiltrados.find(
                        t => t.Id == this.segmentoSeleccionadoId
                    );
                    //console.log(segmentoSeleccionado);

                    if (segmentoSeleccionado) {
                        this.servicio.segmento = segmentoSeleccionado;
                    } else {
                        this.servicio.segmento = data.servicio.segmento;
                        this.segmentoSeleccionadoId = null;
                    }
                } else {
                    this.servicio.segmento = data.servicio.segmento;
                }
                this.segmentoSeleccionEscritura(this.servicio.segmento);

                //MANEJO CLIENTE
                if (this.clienteSeleccionadoId) {
                    const clienteSeleccionado = this.clientesFiltrados.find(
                        t => t.id == this.clienteSeleccionadoId
                    );
                    if (clienteSeleccionado) {
                        this.servicio.cliente = clienteSeleccionado;
                    } else {
                        this.servicio.cliente = data.servicio.cliente;
                        this.clienteSeleccionadoId = null;
                    }
                } else {
                    this.servicio.cliente = data.servicio.cliente;
                }
                this.clienteSeleccionEscritura(this.servicio.cliente);

                //MANEJO ENCARGADO
                this.$nextTick(() => {
                    if (this.usuarioEncargadoSeleccionadoId) {
                        const usuarioEncargadoSeleccionado = this.usuariosFiltrados.find(
                            t => t.id == this.usuarioEncargadoSeleccionadoId
                        );
                        if (usuarioEncargadoSeleccionado) {
                            this.servicio.usuario_encargado = usuarioEncargadoSeleccionado;
                        } else {
                            this.servicio.usuario_encargado = data.servicio.usuario_encargado;
                            this.usuarioEncargadoSeleccionadoId = null;
                        }
                    } else {
                        this.servicio.usuario_encargado = data.servicio.usuario_encargado;
                    }
                    this.usuarioEncargadoSeleccionEscritura(this.servicio.usuario_encargado);
                });


                this.canalSeleccionado = data.servicio.canal_id;
                this.subcanalSeleccionado = data.servicio.subcanal_id;

                this.ventana = data.ventanas.map(v => ({
                    dia: v.dia_semana,
                    inicio: v.hora_apertura.substr(0, 5),
                    fin: v.hora_cierre.substr(0, 5)
                }));
                this.diasSeleccionados = this.ventana.map(v => v.dia);

                if (this.ventana.length > 0) {
                    this.horaInicioBase = this.ventana[0].inicio;
                    this.horaFinBase = this.ventana[0].fin;
                } else {
                    this.horaInicioBase = null;
                    this.horaFinBase = null;
                }
                const auxiliaresParaFormulario = (data.reglas.auxiliares || []).map(aux => ({
                    ...aux,

                    // Jornada: decimal -> hh:mm
                    jornada_min: this.convertirDecimalAHHMM(aux.jornada_min),
                    jornada_max: this.convertirDecimalAHHMM(aux.jornada_max),

                    // Límites: decimal -> hh:mm
                    min_desde_inicio: this.convertirDecimalAHHMM(aux.min_desde_inicio),
                    max_antes_fin: this.convertirDecimalAHHMM(aux.max_antes_fin),

                    // Duración antigua hh:mm:ss -> hh:mm
                    duracion: this.convertirHHMMSSAHHMM(aux.duracion),

                    // Se conservan los minutos porque otros módulos los utilizan
                    min_desde_inicio_min: Number(aux.min_desde_inicio_min ?? 0),
                    max_antes_fin_min: Number(aux.max_antes_fin_min ?? 0)
                }));
                this.reglas = {
                    descansos_semana: data.reglas.max_descansos_por_agente,
                    descanso_interdia: data.reglas.tiempo_descanso_interdia,
                    utilizacion: data.shrinkage.utz,
                    ausentismo: data.shrinkage.abs,
                    shrinkage: data.shrinkage.porcentaje,
                    auxiliares: auxiliaresParaFormulario
                };
                //this.listaTurnos = data.turnos;
                this.listaTurnos = data.turnos.map(turno => {
                    return {
                        ...turno,
                        _key: turno.id
                            ? `bd_${turno.id}`
                            : this.generarKeyTurno(),
                        // Si el backend envía "08:00:00", esto lo deja en "08:00"
                        intervalo_inicio: turno.intervalo_inicio ? turno.intervalo_inicio.slice(0, 5) : '',
                        intervalo_fin: turno.intervalo_fin ? turno.intervalo_fin.slice(0, 5) : ''
                    };
                });
                this.$toast.info(`Editando servicio: ${data.servicio.nombre}`);
                this.tab = 1;

            } catch (err) {
                console.error(err);
                this.$toast.error('Error al cargar el servicio');
            } finally {
                this.cargandoEdicion = false
            }
        },
        eliminarServicio(item) {
            this.dialogEliminar.id = item.id;
            this.dialogEliminar.nombre = item.nombre;
            this.dialogEliminar.visible = true;
        },
        async confirmarEliminacion() {
            try {
                const res = await this.$axios.delete(`servicio/${this.dialogEliminar.id}`);
                if (res.data.status === 'ok') {
                    this.$toast.success('Servicio eliminado correctamente');
                    await this.cargarServicios();
                } else {
                    this.$toast.error('Error al eliminar');
                }
            } catch (err) {
                console.error(err);
                this.$toast.error('Error de conexión al eliminar');
            } finally {
                this.dialogEliminar.visible = false;
            }
        },
        limpiarFormulario() {
            this.servicioId = null;
            this.servicio = {
                nombre: '',
                cliente: '',
                sede: '',
                usuario_solicita: this.$store.state.username,
                usuario_encargado: '',
                fecha_elaboracion: new Date().toISOString().substr(0, 10),
                fecha_vigencia_inicio: '',
                fecha_vigencia_fin: ''
            };
            this.servicioSeleccionadoId = null;
            this.canalesCargados = [];
            this.subcanalesCargados = [];
            this.canalSeleccionado = null;
            this.subcanalSeleccionado = null;
            this.diasSeleccionados = [];
            this.selectAllDays = false;
            this.horaInicioBase = '';
            this.horaFinBase = '';
            this.ventana = [];
            this.reglas = {
                descansos_semana: 2,
                descanso_interdia: 15,
                shrinkage: 10.0,
                auxiliares: []
            };
            this.tab = 1;
            this.listaTurnos = [];
        },
        generarIntervalos() {
            const intervalos = [];
            for (let h = 0; h < 24; h++) {
                for (let m = 0; m < 60; m += 30) {
                    const hora = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
                    intervalos.push(hora);
                }
            }
            return intervalos;
        },
        async importarAuxiliares() {
            if (!this.servicioOrigenSeleccionado) {
                this.$toast.warning('Por favor, selecciona un servicio origen.');
                return;
            }

            this.mostrarSelectorImportar = false;

            const servicioOrigen = this.servicioOrigenSeleccionado;

            //nuevo
            const auxiliaresParaFormulario =
                JSON.parse(servicioOrigen.auxiliares).map(aux => ({
                    ...aux,

                    jornada_min: this.convertirDecimalAHHMM(aux.jornada_min),
                    jornada_max: this.convertirDecimalAHHMM(aux.jornada_max),

                    min_desde_inicio: this.convertirDecimalAHHMM(aux.min_desde_inicio),
                    max_antes_fin: this.convertirDecimalAHHMM(aux.max_antes_fin),

                    duracion: this.convertirHHMMSSAHHMM(aux.duracion)
                }));
            ////

            let nuevosAuxiliares;
            try {
                nuevosAuxiliares = auxiliaresParaFormulario;

            } catch (error) {
                console.error("Error al parsear auxiliares:", error);
                this.$toast.error("Error al procesar las reglas del servicio origen. El formato es incorrecto.");
                return;
            }
            this.reglas.auxiliares = nuevosAuxiliares;

            this.mostrarSelectorImportar = false;
            this.servicioOrigenSeleccionado = null;

            this.$toast.success(`Reglas auxiliares importadas exitosamente desde "${servicioOrigen.nombre}".`);
        },
        //////////////// TURNOS Y JORNADAS ////////////////////
        generarIntervalos() {
            const intervalos = [];
            for (let h = 0; h < 24; h++) {
                for (let m = 0; m < 60; m += 30) {
                    const hora = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
                    intervalos.push(hora);
                }
            }
            return intervalos;
        },
        validarInicio(turno) {
            if (this.esServicio24HorasActual) {
                return true;
            }
            if (!this.ventana[0]) {
                return true;
            }
            if (!turno.intervalo_inicio) {
                return true;
            }
            const inicio = turno.intervalo_inicio?.slice(0, 5);
            const horasValidas = this.generarHorasValidas(
                this.ventana[0].inicio,
                this.ventana[0].fin
            );

            return horasValidas.includes(inicio)
                ? true
                : 'Hora fuera del rango permitido';
        },
        validarFin(turno) {
            const inicio = turno.intervalo_inicio;
            const fin = turno.intervalo_fin;
            const ventana = this.ventana[0];

            if (!inicio || !fin || !ventana) {
                return true;
            }

            if (this.esServicio24HorasActual && inicio === '00:00' && fin === '00:00') {
                return true; // Permite guardar el turno completo de 24 horas
            }

            const aperturaMins = this.tiempoAMinutos(ventana.inicio);
            const cierreMins = this.tiempoAMinutos(ventana.fin);
            const inicioTurnoMins = this.tiempoAMinutos(inicio);
            let finTurnoMins = this.tiempoAMinutos(fin);

            if (fin === '00:00' && inicioTurnoMins > 0) {
                finTurnoMins = 1440;
            }

            const esHorarioNocturno = aperturaMins >= cierreMins;


            if (esHorarioNocturno) {
                if (finTurnoMins < inicioTurnoMins) {
                    finTurnoMins += 1440;
                }

                let cierreAjustado = cierreMins;
                if (cierreMins <= aperturaMins) {
                    cierreAjustado += 1440;
                }

                if (finTurnoMins > cierreAjustado) {
                    return `Debe ser ≤ ${ventana.fin}`;
                }

            } else {

                // 1. Fin no puede ser mayor que Cierre
                if (finTurnoMins > cierreMins) {
                    return `Debe ser ≤ ${ventana.fin}`;
                }
            }

            if (finTurnoMins <= inicioTurnoMins) {
                return 'La hora de fin debe ser posterior a la de inicio.';
            }

            return true;
        },

        generarHorasValidas(horaApertura, horaCierre) {
            const formato = '2000-01-01T';
            const pasoMinutos = 30;

            let inicio = new Date(`${formato}${horaApertura}:00`);
            let fin = new Date(`${formato}${horaCierre}:00`);

            if (fin <= inicio) {
                fin.setDate(fin.getDate() + 1);
            }

            const horas = [];
            while (inicio <= fin) {
                horas.push(inicio.toTimeString().slice(0, 5));
                inicio.setMinutes(inicio.getMinutes() + pasoMinutos);
            }

            return horas;
        },
        tiempoAMinutos(hora) {
            if (!hora) return 0;
            const [h, m] = hora.split(':').map(Number);
            return (h * 60) + m;
        },


        ///METODOS DE TURNOS///
        agregarTurno() {
            const turnoParaAgregar = {
                _key: this.indiceEdicionTurno > -1
                    ? this.listaTurnos[this.indiceEdicionTurno]._key
                    : this.generarKeyTurno(),

                nombre: this.nombreTurnoGenerado,
                intervalo_inicio: this.nuevoTurno.intervalo_inicio,
                intervalo_fin: this.nuevoTurno.intervalo_fin,
                dias_aplicables: [...this.nuevoTurno.dias_aplicables]
            };

            const existeDuplicado = this.listaTurnos.some((t, index) => {
                if (index === this.indiceEdicionTurno) return false;

                return t.nombre === turnoParaAgregar.nombre &&
                    t.intervalo_inicio === turnoParaAgregar.intervalo_inicio &&
                    t.intervalo_fin === turnoParaAgregar.intervalo_fin;
            });

            if (existeDuplicado) {
                this.$toast.error('Este turno ya existe en la lista con el mismo nombre y horario.');
                return;
            }
            //this.listaTurnos.push(turnoParaAgregar);
            if (this.indiceEdicionTurno > -1) {
                this.listaTurnos.splice(this.indiceEdicionTurno, 1, turnoParaAgregar);
                this.$toast.info('Turno actualizado en la lista');
            } else {
                this.listaTurnos.push(turnoParaAgregar);
                this.$toast.success('Turno agregado');
            }

            this.resetFormularioTurno();
        },
        resetFormularioTurno() {
            this.nuevoTurno = {
                servicio_id: null,
                nombre: '',
                intervalo_inicio: '',
                intervalo_fin: '',
                dias_aplicables: []
            }
            this.indiceEdicionTurno = -1;
            this.selectAllDiasAplicables = false;
        },
        eliminarTurno(index) {
            this.listaTurnos.splice(index, 1);
        },
        seleccionarTodosLosTurnos({ items, value }) {

            if (value) {
                this.turnosSeleccionados = [...this.listaTurnos];
            } else {
                this.turnosSeleccionados = [];
            }
        },
        generarKeyTurno() {
            return `turno_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        },

        eliminarTurnosMasivo() {
            this.dialogoConfirmarBorrado = true;
        },

        confirmarEliminacionMasiva() {
            const keysEliminar = new Set(
                this.turnosSeleccionados.map(turno => turno._key)
            );

            this.listaTurnos = this.listaTurnos.filter(
                turno => !keysEliminar.has(turno._key)
            );

            this.turnosSeleccionados = [];

            this.dialogoConfirmarBorrado = false;

            this.mostrarToastExito = true;
        },
        prepararEdicionTurno(item, index) {
            this.indiceEdicionTurno = index;
            this.nuevoTurno = {
                ...item,
                intervalo_inicio: item.intervalo_inicio.slice(0, 5),
                intervalo_fin: item.intervalo_fin.slice(0, 5),
                dias_aplicables: [...item.dias_aplicables]
            };
        },
        mostrarDialogoGeneracion() {
            this.diasSeleccionadosGeneracion = [];
            this.dialogoGeneracion = true;
        },
        async cargarDiasGeneracion() {
            //console.log(this.ventana);
            const ventanaOperativaCompleta = this.ventana;

            const diasUnicos = ventanaOperativaCompleta.map(item => item.dia);

            this.diasDisponiblesGeneracion = diasUnicos;
            this.diasSeleccionadosGeneracion = [];

            if (diasUnicos.length === 1) {
                this.diasSeleccionadosGeneracion = [diasUnicos[0]];
            }
        },
        async generarTurnosAutomaticos() {
            const ventanaOperativaCompleta = this.ventana;

            const ventanaFiltrada = ventanaOperativaCompleta.filter(item =>
                this.diasSeleccionadosGeneracion.includes(item.dia)
            );

            if (ventanaFiltrada.length === 0) {
                alert("Error: Ninguno de los días seleccionados tiene una Ventana Operativa definida en el sistema.");
                return;
            }

            let horaInicioComun = ventanaFiltrada[0].inicio;
            let horaFinComun = ventanaFiltrada[0].fin;

            for (const dia of ventanaFiltrada) {
                if (dia.inicio < horaInicioComun) {
                    horaInicioComun = dia.inicio;
                }
                if (dia.fin > horaFinComun) {
                    horaFinComun = dia.fin;
                }
            }

            const esServicio24Horas = horaInicioComun.substring(0, 5) === horaFinComun.substring(0, 5);

            //this.horaInicioTimeline = horaInicioComun.substring(0, 5);
            //this.horaFinTimeline = esServicio24Horas ? "24:00" : horaFinComun.substring(0, 5);
            //this.horaFinTimeline = horaFinComun.substring(0, 5);       // Ej: "16:00"
            //this.calcularEjeHorario(this.horaInicioTimeline, this.horaFinTimeline);


            /*const turnosAGuardar = [];
            const duracion = this.duracionTurnoMinutos;
            const intervaloInicio = this.tipoGeneracion === 'escalonado' ? duracion : this.intervaloEntreTurnosMinutos;
            let contadorTurno = 1;

            let currentTime = this.obtenerTiempo(horaInicioComun);
            const finalTime = this.obtenerTiempo(horaFinComun);

            const esHorarioNocturno = finalTime.getTime() < currentTime.getTime();

            if (esServicio24Horas || esHorarioNocturno) {
                finalTime.setDate(finalTime.getDate() + 1);

                
            }

            while (currentTime.getTime() < finalTime.getTime()) {

                let nextTime = new Date(currentTime.getTime() + duracion * 60000);

                if (nextTime.getTime() > finalTime.getTime()) {
                    break;
                }

                turnosAGuardar.push({
                    nombre: `Bloque ${contadorTurno} (${this.formatoHora(currentTime)} - ${this.formatoHora(nextTime)})`,
                    intervalo_inicio: this.formatoHora(currentTime),
                    intervalo_fin: this.formatoHora(nextTime),
                    dias_aplicables: this.diasSeleccionadosGeneracion,
                });

                currentTime = new Date(currentTime.getTime() + intervaloInicio * 60000);
                contadorTurno++;
            }

            this.listaTurnos = [...this.listaTurnos, ...turnosAGuardar];*/
            const duracion = this.duracionTurnoMinutos;
            const intervaloInicio = this.tipoGeneracion === 'escalonado' ? duracion : this.intervaloEntreTurnosMinutos;

            // Usamos la hora que el cliente eligió en el formulario
            // Si no eligió nada, usamos la de la ventana por defecto
            let horaInicial = (this.esServicio24HorasActual && this.horaInicioCiclo)
                ? this.horaInicioCiclo
                : horaInicioComun.substring(0, 5);

            let currentTime = this.obtenerTiempo(horaInicial);

            // El final siempre será +24 horas desde donde empezamos para cubrir el ciclo completo
            let finalTime;
            if (this.esServicio24HorasActual) {
                finalTime = new Date(currentTime.getTime() + 24 * 60 * 60000);
            } else {
                finalTime = this.obtenerTiempo(horaFinComun);
                if (finalTime < currentTime) finalTime.setDate(finalTime.getDate() + 1);
            }

            let contadorTurno = 1;
            const turnosAGuardar = [];

            while (currentTime.getTime() < finalTime.getTime()) {
                let nextTime = new Date(currentTime.getTime() + duracion * 60000);

                // --- EL FILTRO DE SEGURIDAD ---
                // Si NO es 24 horas, no permitimos que el turno termine después del cierre de la ventana
                if (!this.esServicio24HorasActual) {
                    if (nextTime.getTime() > finalTime.getTime()) {
                        break; // Aquí se detiene y te vuelve a dar tus 11 turnos exactos
                    }
                }
                // Si ES 24 horas, el 'if' de arriba se ignora y genera la madrugada completa
                // ------------------------------

                turnosAGuardar.push({
                    _key: this.generarKeyTurno(),

                    nombre: `Bloque ${contadorTurno} (${this.formatoHora(currentTime)} - ${this.formatoHora(nextTime)})`,
                    intervalo_inicio: this.formatoHora(currentTime),
                    intervalo_fin: this.formatoHora(nextTime),
                    dias_aplicables: this.diasSeleccionadosGeneracion,
                });

                currentTime = new Date(currentTime.getTime() + intervaloInicio * 60000);
                contadorTurno++;
            }

            this.listaTurnos = [...this.listaTurnos, ...turnosAGuardar];
            this.listaTurnos.sort((a, b) => a.intervalo_inicio.localeCompare(b.intervalo_inicio));
            //this.listaTurnos = turnosAGuardar;
            this.dialogoGeneracion = false;
        },
        /*calcularEjeHorario(inicioStr, finStr) {
            this.horasTimeline = [];
            let start = this.obtenerTiempo(inicioStr);
            const end = this.obtenerTiempo(finStr);

            while (start <= end) {
                this.horasTimeline.push(this.formatoHora(start));
                start = new Date(start.getTime() + 60 * 60000);
            }
        },*/
        calcularEjeHorario(inicioStr, finStr) {
            this.horasTimeline = [];
            let start = this.obtenerTiempo(inicioStr);
            let end = this.obtenerTiempo(finStr);

            // Si es un servicio de 24 horas (inicio y fin son iguales) 
            // o si el fin es menor al inicio (cruza la medianoche)
            if (inicioStr === finStr || end < start) {
                end.setDate(end.getDate() + 1);
            }

            // Usamos una copia para no modificar el objeto original en el loop
            let tempStart = new Date(start.getTime());

            // Agregamos una marca cada hora
            while (tempStart <= end) {
                this.horasTimeline.push(this.formatoHora(tempStart));
                tempStart = new Date(tempStart.getTime() + 60 * 60000); // +60 minutos
            }
        },
        formatoHora(date) {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${hours}:${minutes}`;
        },
        obtenerTiempo(hora) {
            const [h, m] = hora.split(':');
            const date = new Date();
            date.setHours(parseInt(h), parseInt(m), 0, 0);
            return date;
        },
        /*getTurnoEstilo(turno, index) {
            if (!this.horaInicioTimeline || !this.horaFinTimeline) return {};

            const totalMinutosVentana = this.calcularMinutosDesdeMedianoche(this.horaFinTimeline) - this.calcularMinutosDesdeMedianoche(this.horaInicioTimeline);
            const inicioTurnoMinutos = this.calcularMinutosDesdeMedianoche(turno.intervalo_inicio);
            const finTurnoMinutos = this.calcularMinutosDesdeMedianoche(turno.intervalo_fin);
            const inicioVentanaMinutos = this.calcularMinutosDesdeMedianoche(this.horaInicioTimeline);

            const duracionTurnoMinutos = finTurnoMinutos - inicioTurnoMinutos;
            const desplazamientoMinutos = inicioTurnoMinutos - inicioVentanaMinutos;

            const width = (duracionTurnoMinutos / totalMinutosVentana) * 100;
            const left = (desplazamientoMinutos / totalMinutosVentana) * 100;

            const colorIndex = index % this.coloresTimeline.length;
            const color = this.coloresTimeline[colorIndex];

            let top;
            let zIndex;

            top = `${index * this.alturaCarril + 10}px`;
            zIndex = 10 + index;

            return {
                width: `${width}%`,
                left: `${left}%`,
                backgroundColor: color,
                top: top,
                zIndex: zIndex,
            };
        },*/
        getTurnoEstilo(turno, index) {
            if (!this.horaInicioTimeline || !this.horaFinTimeline) return {};

            // 1. Calcular duración total de la ventana (Eje X completo)
            let minInicioVentana = this.calcularMinutosDesdeMedianoche(this.horaInicioTimeline);
            let minFinVentana = this.calcularMinutosDesdeMedianoche(this.horaFinTimeline);

            // Si es 24h o cruza medianoche (ej: 22:00 a 06:00)
            if (minFinVentana <= minInicioVentana) {
                minFinVentana += 1440; // Sumamos 24 horas en minutos
            }
            const totalMinutosEje = minFinVentana - minInicioVentana;

            // 2. Calcular tiempos del turno
            let minInicioTurno = this.calcularMinutosDesdeMedianoche(turno.intervalo_inicio);
            let minFinTurno = this.calcularMinutosDesdeMedianoche(turno.intervalo_fin);

            // Ajuste: Si el inicio del turno es menor al inicio de la ventana, 
            // significa que el turno empieza al día siguiente dentro de la ventana nocturna
            if (minInicioTurno < minInicioVentana) {
                minInicioTurno += 1440;
                minFinTurno += 1440;
            } else if (minFinTurno < minInicioTurno) {
                // El turno mismo cruza la medianoche (ej: empieza 23:00 termina 07:00)
                minFinTurno += 1440;
            }

            // 3. Cálculos de posición
            const duracionTurno = minFinTurno - minInicioTurno;
            const desplazamiento = minInicioTurno - minInicioVentana;

            const width = (duracionTurno / totalMinutosEje) * 100;
            const left = (desplazamiento / totalMinutosEje) * 100;

            // 4. Estética y Apilamiento
            const color = this.coloresTimeline[index % this.coloresTimeline.length];

            let top = `${index * this.alturaCarril + 10}px`;

            return {
                width: `${width}%`,
                left: `${left}%`,
                backgroundColor: color,
                top: top,
                position: 'absolute',
                height: '25px',
                borderRadius: '4px',
                zIndex: 10 + index,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid rgba(0,0,0,0.1)'
            };
        },

        calcularMinutosDesdeMedianoche(horaStr) {
            const [h, m] = horaStr.split(':').map(Number);
            return h * 60 + m;
        },
        prepararTimeline() {
            if (this.listaTurnos.length === 0) {
                this.$toast.warning("No hay turnos para visualizar");
                return;
            }

            // 1. Determinar el rango horario basado en la ventana operativa completa
            // (Similar a lo que hacías en la generación automática)
            let horaInicioComun = this.ventana[0].inicio;
            let horaFinComun = this.ventana[0].fin;

            for (const dia of this.ventana) {
                if (dia.inicio < horaInicioComun) horaInicioComun = dia.inicio;
                if (dia.fin > horaFinComun) horaFinComun = dia.fin;
            }

            const esServicio24Horas = horaInicioComun.substring(0, 5) === horaFinComun.substring(0, 5);

            // 2. Setear las variables que el template necesita
            this.horaInicioTimeline = horaInicioComun.substring(0, 5);
            this.horaFinTimeline = esServicio24Horas ? "24:00" : horaFinComun.substring(0, 5);

            // 3. Generar el eje (los numeritos de arriba 08:00, 09:00...)
            this.calcularEjeHorario(this.horaInicioTimeline, this.horaFinTimeline);

            // 4. Abrir el diálogo
            this.cobertura = true;
        },
        async cargarCatalogo() {
            this.cargando = true;
            try {
                const usuarioId = this.$store.state.id;
                const res = await this.$axios.get(`catalogo-turnos?usuario=${usuarioId}`);
                this.turnosCatalogo = res.data.map(t => ({
                    ...t,
                    dias_aplicables: Array.isArray(t.dias_aplicables) ? t.dias_aplicables : t.dias_aplicables.replace('{', '').replace('}', '').split(',') // si lo guardaste como TEXT[]
                }));
                //console.log(this.turnosCatalogo);
            } catch (error) {
                console.error(error);
                this.$toast.error('Error de conexión');
            } finally {
                this.cargando = false;
            }

        },
        async prepararVistaPrevia() {
            if (!this.servicioOrigenSeleccionadoTurno) {
                this.$toast.warning('Por favor, selecciona el servicio origen.');
                return;
            }

            const idServicioOrigen = this.servicioOrigenSeleccionadoTurno.id;

            const turnosDelOrigen = this.turnosCatalogo.filter(
                turno => turno.servicio_id === idServicioOrigen
            );
            //console.log(turnosDelOrigen);

            if (turnosDelOrigen.length === 0) {
                this.$toast.error(`El servicio "${this.servicioOrigenSeleccionadoTurno.nombre}" no tiene bloques de turno registrados.`);
                this.turnosCopiadosTemporal = [];
                return;
            }

            this.turnosCopiadosTemporal = turnosDelOrigen.map((turno, index) => {
                const inicio = turno.intervalo_inicio.slice(0, 5);
                const fin = turno.intervalo_fin.slice(0, 5);
                let nuevoTurno = {
                    ...turno,
                    intervalo_inicio: inicio,
                    intervalo_fin: fin,
                    id: null,
                    creado_en: null,
                    esValido: true,
                    razonInvalidez: null,
                    nombre: `Bloque ${index + 1} (${inicio} - ${fin})`
                };

                const validacion = this.validarTurnoImportado(nuevoTurno);

                if (!validacion.esValido) {
                    nuevoTurno.esValido = false;
                    nuevoTurno.razonInvalidez = validacion.razon;
                }

                return nuevoTurno;
            });
            const turnosInvalidos = this.turnosCopiadosTemporal.filter(t => !t.esValido);
            const totalInvalidos = turnosInvalidos.length;

            if (totalInvalidos > 0) {

                const resumenErrores = turnosInvalidos.reduce((acc, turno) => {
                    let tipoError;
                    if (turno.razonInvalidez.includes('No tiene ventana configurada')) {
                        tipoError = 'Día No Configurado';
                    } else if (turno.razonInvalidez.includes('fuera del rango')) {
                        tipoError = 'Inicio Fuera de Rango';
                    } else if (turno.razonInvalidez.includes('excede el cierre')) {
                        tipoError = 'Fin Excede Cierre';
                    } else {
                        tipoError = 'Error Desconocido';
                    }

                    acc[tipoError] = (acc[tipoError] || 0) + 1;
                    return acc;
                }, {});

                const listaErrores = Object.keys(resumenErrores).map(razon => {
                    return `${resumenErrores[razon]} por "${razon}"`;
                }).join(', ');


                const mensajeDetallado = `Se cargaron ${totalInvalidos} turnos inválidos. Problemas principales: ${listaErrores}. Revise la columna 'Estado' en la tabla.`;

                this.$toast.warning(mensajeDetallado, { timeout: 10000 });
            }
        },
        obtenerVentanaPorDia(diaSemana) {
            return this.ventana.find(ventana => ventana.dia === diaSemana);
        },
        validarTurnoImportado(turno) {
            const resultado = { esValido: true, razon: null };
            const inicioTurno = turno.intervalo_inicio;
            const finTurno = turno.intervalo_fin;

            const tiempoAMinutos = (timeStr) => {
                if (!timeStr) return 0;
                const [h, m] = timeStr.split(':').map(Number);
                return (h * 60) + m;
            };

            for (const dia of turno.dias_aplicables) {
                const ventana = this.obtenerVentanaPorDia(dia);
                //console.log(ventana);

                if (!ventana) {
                    resultado.esValido = false;
                    resultado.razon = `Día ${dia}: No tiene ventana configurada en el destino.`;
                    return resultado;
                }

                const aperturaVentana = ventana.inicio;
                const cierreVentana = ventana.fin;

                const esVentana24Horas = (aperturaVentana === cierreVentana); // ⭐️ Nueva Definición

                // --- INICIO: VALIDACIÓN DE INICIO DE TURNO EN RANGO ---
                if (!esVentana24Horas) {
                    const horasValidas = this.generarHorasValidas(aperturaVentana, cierreVentana);

                    if (!horasValidas.includes(inicioTurno)) {
                        resultado.esValido = false;
                        resultado.razon = `Día ${dia}: Inicio (${inicioTurno}) fuera del rango (${aperturaVentana} - ${cierreVentana}).`;
                        return resultado;
                    }
                }


                const aperturaMin = tiempoAMinutos(aperturaVentana);
                let cierreMin = tiempoAMinutos(cierreVentana);
                let inicioTurnoMin = tiempoAMinutos(inicioTurno);
                let finTurnoMin = tiempoAMinutos(finTurno);

                const cruzaMedianoche = esVentana24Horas || (cierreVentana <= aperturaVentana);

                if (cruzaMedianoche) {
                    if (esVentana24Horas) {
                        cierreMin = 2880;
                    } else {
                        cierreMin += 1440;
                    }

                    if (esVentana24Horas && finTurnoMin === inicioTurnoMin) {
                        finTurnoMin += 1440;
                    }
                    else if (finTurnoMin < inicioTurnoMin) {
                        finTurnoMin += 1440;
                    }

                    if (inicioTurnoMin < aperturaMin) {
                        inicioTurnoMin += 1440;
                    }
                }

                if (finTurnoMin > cierreMin) {
                    resultado.esValido = false;
                    resultado.razon = `Día ${dia}: Fin (${finTurno}) excede el cierre (${cierreVentana}).`;
                    return resultado;
                }

                if (finTurnoMin <= inicioTurnoMin) {
                    resultado.esValido = false;
                    resultado.razon = `Día ${dia}: El fin (${finTurno}) debe ser posterior al inicio (${inicioTurno}).`;
                    return resultado;
                }

            }

            return resultado;
        },
        async guardarTurnosImportados() {
            if (this.turnosCopiadosTemporal.length === 0) {
                this.isSaving = false;
                this.$toast.error('No hay turnos para importar');
                return;
            }
            const turnosAGuardar = this.turnosCopiadosTemporal.map(turno => {
                return {
                    _key: turno._key || this.generarKeyTurno(),

                    nombre: turno.nombre,
                    intervalo_inicio: turno.intervalo_inicio,
                    intervalo_fin: turno.intervalo_fin,
                    dias_aplicables: turno.dias_aplicables,
                };
            });

            this.listaTurnos = turnosAGuardar;

            // Limpiar estado y cerrar modal
            this.mostrarSelectorImportarTurnos = false;
            this.turnosCopiadosTemporal = [];
            this.servicioOrigenSeleccionadoTurno = null;
            this.servicioDestinoSeleccionado = null;
            this.turnoEditando = null;

        },
        editarTurnoTemporal(item, index) {
            let turno = { ...item };
            if (turno.intervalo_inicio) {
                turno.intervalo_inicio = turno.intervalo_inicio.slice(0, 5);
            }
            if (turno.intervalo_fin) {
                turno.intervalo_fin = turno.intervalo_fin.slice(0, 5);
            }
            this.turnoEditando = turno;
            this.indiceEditando = index;
        },
        eliminarTurnoTemporal(index) {
            const turno = this.turnosCopiadosTemporal[index];

            this.turnosCopiadosTemporal.splice(index, 1);

            this.$toast.success(`Turno "${turno.nombre}" eliminado de la previsualización.`);

            if (this.indiceEditando === index) {
                this.turnoEditando = null;
                this.indiceEditando = -1;
            }
        },
        async guardarEdicionTemporal() {
            if (this.indiceEditando === -1 || !this.turnoEditando) {
                this.$toast.error('Error: No hay un turno en edición.');
                return;
            }

            const validacion = this.validarTurnoImportado(this.turnoEditando);

            this.turnoEditando.esValido = validacion.esValido;
            this.turnoEditando.razonInvalidez = validacion.razon;

            this.$set(this.turnosCopiadosTemporal, this.indiceEditando, this.turnoEditando);

            if (validacion.esValido) {
                this.$toast.success('Turno editado y validado correctamente.');
            } else {
                this.$toast.warning(`Turno editado, pero aún inválido: ${validacion.razon}`);
            }

            this.turnoEditando = null;
            this.indiceEditando = -1;
        },
        verTurnos(item) {
            this.servicioSeleccionadoTurno = item; // Guardamos el servicio (id: 65, nombre: "menor costo", etc)
            this.dialogVerTurnos = true;
        },
        async irAEditarTurnos() {
            this.dialogVerTurnos = false;

            await this.editarServicio(this.servicioSeleccionadoTurno);

            this.$nextTick(() => {
                this.tab = 5;

                //this.listaTurnos = [...this.turnosFiltrados];
            });
        }

    },
    created() {
        const paisUsuario = this.$store.state.pais || (this.$store.state.usuario && this.$store.state.usuario.paisId);

        if (paisUsuario) {
            this.paisSeleccionadoId = Number(paisUsuario);
        }
    },
}
export default Services